module.exports = __webpack_public_path__ + "assets/img/user-10.dde0d81f.jpg";